import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore, useModalStore } from '@/stores'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import ForgotPasswordView from '@/views/ForgotPasswordView.vue'
import AccountView from '@/views/AccountView.vue'
import RouteView from '@/views/RouteView.vue'
import NotificationsView from '@/views/NotificationsView.vue'
import ScannerView from '@/views/ScannerView.vue'
import MyRoutesView from '@/views/MyRoutesView.vue'
import SelectCompanyView from '@/views/SelectCompanyView.vue'
import SearchView from '@/views/SearchView.vue'
import BalancesView from '@/views/BalancesView.vue'
import TransactionsView from '@/views/TransactionsView.vue'
import TransactionFormView from '@/views/TransactionFormView.vue'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    linkActiveClass: 'active',
    routes: [
        {
            path: '/login',
            name: 'loginPage',
            component: LoginView
        },
        {
            path: '/forgot-password',
            name: 'forgotPasswordPage',
            component: ForgotPasswordView
        },
        {
            path: '/company-select',
            name: 'companySelectPage',
            component: SelectCompanyView
        },
        {
            path: '/',
            name: 'homePage',
            component: HomeView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/search',
            name: 'searchPage',
            component: SearchView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/my-routes',
            name: 'myRoutesPage',
            component: MyRoutesView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/balances',
            name: 'balancesPage',
            component: BalancesView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/transactions',
            name: 'transactionsPage',
            component: TransactionsView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/create-transaction',
            name: 'createTransactionPage',
            component: TransactionFormView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/edit-transaction/:id',
            name: 'editTransactionPage',
            component: TransactionFormView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/account',
            name: 'accountPage',
            component: AccountView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/route',
            name: 'routePage',
            component: RouteView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/notifications',
            name: 'notificationsPage',
            component: NotificationsView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/scanner',
            name: 'scannerPage',
            component: ScannerView,
            meta: {
                requiresAuth: true
            }
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()
    const modalStore = useModalStore()

    if (to.path !== from.path || !from.name) {
        modalStore.checkAppVersion()
    }

    if (to.meta.requiresAuth && !authStore.isUserLoggedIn()) {
        next({ name: 'loginPage' })
    } else {
        next()
    }
})

export default router
